import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';

import { setUser } from 'actions/userActions';
import strings from '../../../../strings';
import { userSelector } from '../../../../redux/selectors';
import { legalDocumentsVersion } from '../../../../settings/legalDocumentsVersion';

export const useProfile = ({ updateUserProfile }) => {
  const user = useSelector(userSelector);
  const mode = !user.hasPassword || user.forcePasswordUpdate ? 'email' : 'password';
  const initialValues = {
    avatarUrl: user.avatarUrl || '',
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    ...(mode === 'email' ? { email: user.email } : undefined),
    ...(mode === 'email' ? { password: '' } : undefined),
    termsAccepted: false,
  };
  const dispatch = useDispatch();

  const formSchema = Yup.object().shape({
    firstName: Yup.string().label('First name').required(),
    lastName: Yup.string().label('Last name').required(),
    ...(mode === 'email' ? { email: Yup.string().email().required() } : undefined),
    ...(mode === 'email' ? { password: Yup.string().min(8, strings.validation.passwordLength).required() } : undefined),
    termsAccepted: Yup.boolean().oneOf([true], strings.validation.termsAccepted),
  });

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      privacyPolicyVersion: legalDocumentsVersion.privacyPolicyVersion,
      termsPolicyVersion: legalDocumentsVersion.termsPolicyVersion,
    };
    await updateUserProfile(payload);

    dispatch(setUser(payload));
  };

  return { initialValues, formSchema, mode, onSubmit };
};
